const arrToEnum = arr =>
  arr.reduce((acc, val) => {
    acc[val.toUpperCase()] = val;

    return acc;
  }, {});

export default arrToEnum;
